import React from "react";
import { useBedServices } from "../../hooks/useBedServices";
import { useLocationServices } from "../../hooks/useLocationServices";
import { useStaffService } from "../../hooks/useStaffService";
import { useFormik } from "formik";
import ProDropDown from "./ProDropDown";
import ProAutoComplete from "./ProAutoComplete";
import { Button } from "primereact/button";
import _ from 'lodash'
import { ActiveStatusOptions, OccupancyStatusOptions, ReservationStatusOptions } from "../../constants/ProConstants";

const ProFilter = ({filter, toggleFilter, SetFilter, ResetFilter})=>{
    const { filteredStaff, SearchStaff } = useStaffService();   
    const { programs }  = useLocationServices();
    const { bedStatuses, bedTypes, tagService } = useBedServices();
    const [filteredTags, SearchTag] = tagService;

    const formik = useFormik({
        initialValues: filter,
        validate: (data) => { },
        onSubmit: (data) => {
            toggleFilter(false);
            SetFilter(data);
        },
    });

    const hasFilter = () => {
        return _.drop(_.valuesIn(formik.values)).some(filter => !_.isEmpty(filter))
    }

    const onReset = () => {
        ResetFilter();
        toggleFilter(false);
        formik.resetForm();
    }



    return <form onSubmit={formik.handleSubmit}>
    <div className="p-grid p-justify-between">
        <div className="p-col-2">
            <ProDropDown
                id="bedStatus"
                value={formik.values.bedStatus}
                style={{ width: "100%", marginBottom: "2px" }}
                onChange={formik.handleChange}
                options={bedStatuses}
                optionLabel="name"
                placeholder="Bed Status"
                required
            />
        </div>
        <div className="p-col-2">
            <ProDropDown
                id="occupancyStatus"
                value={formik.values.occupancyStatus}
                style={{ width: "100%", marginBottom: "2px" }}
                onChange={formik.handleChange}
                options={OccupancyStatusOptions}
                optionLabel="name"
                placeholder="Occupancy Status"
                required
            />
        </div>
        <div className="p-col-2">
            <ProDropDown
                id="reservationStatus"
                value={formik.values.reservationStatus}
                style={{ width: "100%", marginBottom: "2px" }}
                onChange={formik.handleChange}
                options={ReservationStatusOptions}
                optionLabel="name"
                placeholder="Reservation Status"
                required
            />
        </div>
        <div className="p-col-2">
            <ProDropDown
                id="activeStatus"
                value={formik.values.activeStatus}
                style={{ width: "100%", marginBottom: "2px" }}
                onChange={formik.handleChange}
                options={ActiveStatusOptions}
                optionLabel="name"
                placeholder="Active Status"
                required
            />
        </div>
        <div className="p-col-4">
            <ProDropDown
                id="program"
                value={formik.values.program}
                style={{ width: "100%", marginBottom: "2px" }}
                onChange={formik.handleChange}
                options={programs}
                optionLabel="name"
                placeholder="Program"
                required
            />
        </div>
        <div className="p-col-2">
            <ProDropDown
                id="bedType"
                value={formik.values.bedType}
                style={{ width: "100%", marginBottom: "2px" }}
                onChange={formik.handleChange}
                options={bedTypes}
                optionLabel="name"
                placeholder="Bed Type"
                required
            />
        </div>

        <div className="p-col-6">
            <ProAutoComplete
                id="bedTags"
                labelText="Tags"
                field="name"
                value={formik.values.bedTags}
                suggestions={filteredTags}
                completeMethod={SearchTag}
                onChange={formik.handleChange}
                required
            />
        </div>
        <div className="p-col-4">
            <ProAutoComplete
                id="bedMngmtStaffDetails"
                labelText="Assigned Staff"
                field="fullName"
                minLength={3}
                value={formik.values.bedMngmtStaffDetails}
                suggestions={filteredStaff}
                completeMethod={SearchStaff}
                onChange={formik.handleChange}
                required
            />
        </div>

    </div>
    <div className="p-grid">
        <div className="p-col p-col-align-start">
            <span onClick={() => toggleFilter()} className="filter-collapse"><i className="fas fa-angle-up" style={{ color: '#6186ba', fontSize: 15 }}></i> Collapse</span>
        </div>
        <div className="p-col p-col-align-end button-text-align-right">
            <Button label="Reset" type="reset" onClick={onReset} className="p-button-text p-button-plain" />
            <Button label="Apply" type="submit" className={hasFilter() ? "p-button-text" : "p-button-text p-disabled"} />
        </div>
    </div>
</form>

}

export default ProFilter;